// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Footer_footer__\\+XNsG {
  width: 100%;
  background: var(--color-gris-claro);
  color: var(--color-secundario);
  padding: 4rem 8rem;
}

.Footer_topRow__EWT-t {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.Footer_brand__eByMb {
  font-size: clamp(1.6rem, 2.2vw, 2rem);
  font-weight: 700;
  color: var(--color-primario);
  letter-spacing: 0.4px;
}

.Footer_social__S4DmY {
  display: inline-flex;
  align-items: center;
  gap: 1rem;
}
.Footer_social__S4DmY a {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  color: var(--color-secundario);
  text-decoration: none;
  transition: transform 0.15s ease, background-color 0.15s ease;
}
.Footer_social__S4DmY a svg {
  font-size: 20px;
}

.Footer_divider__5edt7 {
  margin-top: 0.75rem;
  border-bottom: 2px solid var(--color-secundario);
  opacity: 0.6;
}

.Footer_nav__X-zvX {
  display: flex;
  flex-wrap: wrap;
  gap: 1.25rem;
  padding-top: 0.6rem;
}
.Footer_nav__X-zvX a {
  font-size: var(--font-normal);
  font-weight: 600;
  color: var(--color-secundario);
  text-decoration: none;
  opacity: 0.9;
}

@media (max-width: 640px) {
  .Footer_footer__\\+XNsG {
    padding: 1rem 1rem 0.5rem;
  }
  .Footer_nav__X-zvX {
    gap: 0.9rem;
    font-size: 0.95em;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/layouts/Footer/Footer.module.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,mCAAA;EACA,8BAAA;EACA,kBAAA;AACJ;;AAEE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AACJ;;AAEE;EACE,qCAAA;EACA,gBAAA;EACA,4BAAA;EACA,qBAAA;AACJ;;AAEE;EACE,oBAAA;EACA,mBAAA;EACA,SAAA;AACJ;AACI;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,qBAAA;EACA,6DAAA;AACN;AAAM;EAAM,eAAA;AAGZ;;AAEE;EACE,mBAAA;EACA,gDAAA;EACA,YAAA;AACJ;;AAEE;EACE,aAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;AACJ;AACI;EACE,6BAAA;EACA,gBAAA;EACA,8BAAA;EACA,qBAAA;EACA,YAAA;AACN;;AAGE;EACE;IAAU,yBAAA;EACZ;EAAE;IAAO,WAAA;IAAY,iBAAA;EAIrB;AACF","sourcesContent":[".footer {\n    width: 100%;\n    background: var(--color-gris-claro);\n    color: var(--color-secundario);\n    padding: 4rem 8rem;\n  }\n  \n  .topRow {\n    display: flex;\n    align-items: center;\n    gap: .5rem;\n  }\n  \n  .brand {\n    font-size: clamp(1.6rem, 2.2vw, 2rem);\n    font-weight: 700;\n    color: var(--color-primario);\n    letter-spacing: .4px;\n  }\n  \n  .social {\n    display: inline-flex;\n    align-items: center;\n    gap: 1rem;\n  \n    a {\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      width: 28px;\n      height: 28px;\n      color: var(--color-secundario);\n      text-decoration: none;\n      transition: transform .15s ease, background-color .15s ease;\n      svg { font-size: 20px; }\n\n    }\n  }\n  \n  .divider {\n    margin-top: .75rem;\n    border-bottom: 2px solid var(--color-secundario);\n    opacity: .6;\n  }\n  \n  .nav {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 1.25rem;\n    padding-top: .6rem;\n  \n    a {\n      font-size: var(--font-normal);\n      font-weight: 600;\n      color: var(--color-secundario);\n      text-decoration: none;\n      opacity: .9;\n    }\n  }\n  \n  @media (max-width: 640px) {\n    .footer { padding: 1rem 1rem .5rem; }\n    .nav { gap: .9rem; font-size: .95em; }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": `Footer_footer__+XNsG`,
	"topRow": `Footer_topRow__EWT-t`,
	"brand": `Footer_brand__eByMb`,
	"social": `Footer_social__S4DmY`,
	"divider": `Footer_divider__5edt7`,
	"nav": `Footer_nav__X-zvX`
};
export default ___CSS_LOADER_EXPORT___;
